/* eslint-disable */
import ApiService from '@/services/Base/ApiService';

const getDefaultState = () => {
  return {
    saveSampleCoordinates: {},
  }
}

const state = getDefaultState()

const getters = {
}

const mutations = {
}

const actions = {
  async fetchAncientProxSampleCoordinates(context, { ids, m }) {
    try {
      const cached = context.state.saveSampleCoordinates[m];
      if (cached) {
        return cached;
      }
      const response = await ApiService.post('AncientProxSampleCoordinate', { ancientProxDataIds: ids });
      if (response.statusCode === 200) {
        context.state.saveSampleCoordinates[m] = response.result;
        return response.result;
      } else {
        throw error;
      }
    } catch (error) {
      throw error;
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
